var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "flex w-full overflow-x-hidden",
      attrs: { id: "form-activity", autocomplete: "off" }
    },
    [
      _c(
        "div",
        { staticClass: "w-full p-2" },
        [
          _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
            _c("div", { staticClass: "px-4 mb-6" }, [
              _c("img", {
                staticClass:
                  "shadow rounded max-w-full h-auto align-middle border-none",
                staticStyle: { width: "150px" },
                attrs: {
                  alt: "...",
                  src: _vm.input.cover ? _vm.input.cover : _vm.imgPlaceholder
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.isFileLarge ||
            _vm.isFileWrongFormat ||
            (_vm.$v.input.cover.$dirty && !_vm.$v.input.cover.required)
              ? _c(
                  "div",
                  { staticClass: "flex flex-col mb-2" },
                  [
                    _vm.isFileLarge
                      ? _c("text-error", {
                          attrs: { text: "Please select correct file" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isFileWrongFormat
                      ? _c("text-error", {
                          attrs: { text: "Please use a valid image format" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$v.input.cover.$dirty && !_vm.$v.input.cover.required
                      ? _c("text-error", {
                          attrs: { text: "Please select category image." }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex" },
              [
                !_vm.input.cover
                  ? _c("Button", {
                      attrs: { label: "Browse File" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "any",
                            fn: function() {
                              return [
                                _c("input", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                    left: "0",
                                    top: "0",
                                    opacity: "0",
                                    cursor: "pointer",
                                    "z-index": "2"
                                  },
                                  attrs: {
                                    type: "file",
                                    name: "profile_picture"
                                  },
                                  on: { change: _vm.onFileChange }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2462335240
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.input.cover
                  ? _c("Button", {
                      attrs: { label: "Cancel", variant: "default" },
                      on: { clicked: _vm.changeImage }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Category Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "Category Name",
                        error:
                          _vm.$v.input.name.$dirty &&
                          (!_vm.$v.input.name.required ||
                            !_vm.$v.input.name.maxLength),
                        maxlength: "100"
                      },
                      model: {
                        value: _vm.input.name,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "name", $$v)
                        },
                        expression: "input.name"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill Category Name." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.maxLength
                          ? _c("text-error", {
                              attrs: {
                                text:
                                  "Max length Category name is 100 character."
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col mb-2" }, [
      _c("p", { staticClass: "text-xs text-gray-700" }, [
        _vm._v("Input 596 x 304 px image in JPG or PNG. Max image size 1MB")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c7fbf29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c7fbf29","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Categories/CategoriesForm.vue
// module id = null
// module chunks = 